import { Client } from "@/Common/Api/Client";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Patient } from "@/Common/Models/Patient/Patient";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { GetGdeRedirectUrl } from "../../MedicalItems/Immunization/ResponseModels/GetGdeRedirectUrl";

interface IRadiologyControllerProps {
    patient: Patient;
    siteId: string;
}

class RadiologyFormsController extends BaseReactComponent<IRadiologyControllerProps> {
    public constructor(props: IRadiologyControllerProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (this.renderRadiologyFormsSection());
    }

    private renderRadiologyFormsSection(): JSX.Element {
        return (
            <tr>
                <td className="c1 bottom-pad">
                    <strong>{cacheStore.GetString("RadiologyFormsLabel")}</strong>
                </td>
                <td className="c2">
                    <div className="tb-row tb">
                        <div className="add-btn-column">
                            <a onClick={() => this.handleNewRadiologyForm()}>[+]</a>
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    private async handleNewRadiologyForm(): Promise<void> {
        const eclinibaseId = this.props.patient.ExternalIdentifiers.find(ei => ei.IndexCode === "ECLIN")?.Number;

        const response = await Client.postAsync<GetGdeRedirectUrl>(
            ServerOperations.Server.Gde_GetNewDocumentRedirectUrl,
            {
                EclinibaseId: eclinibaseId,
                SiteId: this.props.siteId
            }
        );

        if (response?.isSuccess && response.data?.RedirectUrl) {
            const redirectUrl = response.data.RedirectUrl;
            MyleHelper.OpenNewTab(redirectUrl);
        }
        else
            sessionStore.showPopup(response.errors);
    }
}

export { RadiologyFormsController };
